import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { SubmitModalContainer } from '../Users/Submit';
import { SubmitBandFinderModalContainer } from '../Users/SubmitBandFinderModal';

import { PinFullViewModalMobile, PinFullViewModalWeb } from '../../Components/ModalsNew';

// actions
import {
    closeBandFinderPinModal,
    openBandFinderPinModal,
} from '../../Actions/main';
import { closeSubmitModal, closeSubmitBandFinderModal, getUserData } from '../../Actions/users';
import { openPinFullViewModal, closePinFullViewModal } from '../../Actions/modals';

// styles
import './styles.css'
import {isMobile} from "../../utils";

class WrapperSideMenu extends Component {
    componentDidMount() {
        this.props.getUserData();
    }

    setPinViewModals() {
        if (isMobile()) {
            return (
                <PinFullViewModalMobile
                    isModalOpen={this.props.isPinFullViewModalOpen}
                    closeModal={this.props.closePinFullViewModal}
                    pin={this.props.pinFullViewData}
                    datatypes={this.props.datatypes}
                />
            )
        }

        return (
            <PinFullViewModalWeb
                isModalOpen={this.props.isPinFullViewModalOpen}
                closeModal={this.props.closePinFullViewModal}
                pin={this.props.pinFullViewData}
                datatypes={this.props.datatypes}
            />
        )
    }

    render() {
        return (
            <div className="main-content-wrapper">
                {this.props.children}
                <SubmitModalContainer
                    isModalOpen={this.props.isSubmitModalOpen}
                    closeModal={this.props.closeSubmitModal}
                />
                <SubmitBandFinderModalContainer
                    isModalOpen={this.props.isSubmitBandFinderModalOpen}
                    closeModal={this.props.closeSubmitBandFinderModal}
                />

                {this.setPinViewModals()}

            </div>
        )
    }
}

WrapperSideMenu.propTypes = {
    children: PropTypes.element,
    closeSubmitModal: PropTypes.func,
    closeSubmitBandFinderModal: PropTypes.func,
    getUserData: PropTypes.func,
    isSubmitModalOpen: PropTypes.bool,
    isSubmitBandFinderModalOpen: PropTypes.bool,

    datatypes: PropTypes.object,
    modalPinData: PropTypes.object,
    pinFullViewData: PropTypes.object,

    // services and live music modals functions
    isModalOpen: PropTypes.bool,
    openPinFullViewModal: PropTypes.func,
    closePinModal: PropTypes.func,

    // band finder functions
    isBandFinderModalOpen: PropTypes.bool,
    openBandFinderPinModal: PropTypes.func,
    closeBandFinderPinModal: PropTypes.func,

    // new modal
    isPinFullViewModalOpen: PropTypes.bool,
    closePinFullViewModal: PropTypes.func
};

const mapStateToProps = (state) => ({
    isSubmitModalOpen: state.users.isSubmitModalOpen,
    isSubmitBandFinderModalOpen: state.users.isSubmitBandFinderModalOpen,
    token: state.users.token,
    pins: state.admin && state.admin.pins || [],
    isModalOpen: state.main.isModalOpen,
    //isBandFinderModalOpen: state.main.isBandFinderModalOpen,
    isPinFullViewModalOpen: state.modals.isPinFullViewModalOpen,
    pinFullViewData: state.modals.pinFullViewData,
    datatypes: state.main.datatypes
});

export default connect(mapStateToProps, {
    closeSubmitModal,
    closeSubmitBandFinderModal,
    closePinFullViewModal,
    closeBandFinderPinModal,
    openPinFullViewModal,
    openBandFinderPinModal,
    getUserData
})(WrapperSideMenu);

/*

                <PinFullPreview
                    isModalOpen={this.props.isModalOpen}
                    closeModal={this.props.closePinModal}
                    modalPinData={this.props.modalPinData}
                    datatypes={this.props.datatypes}
                />

                <PinBandFinderFullPreview
                    isBandFinderModalOpen={this.props.isBandFinderModalOpen}
                    closeBandFinderModal={this.props.closeBandFinderPinModal}
                    modalPinData={this.props.modalPinData}
                    datatypes={this.props.datatypes}
                />

 */



// WEBPACK FOOTER //
// ./src/Components/Wrappers/WrapperSideMenu.js